import { Box } from "@mui/material";
import React from "react";
import { useStyles } from "../PlayerList";

const BoxNumber = ({ parentIndex, childIndex, virtual }) => {
  const classes = useStyles();

  return (
    <>
      {virtual ? (
        <Box className={classes.blackNumBox}>1</Box>
      ) : (
        <>
          {childIndex % 2 == 0 ? (
            <Box className={classes.blackNumBox}>
              {(parentIndex + 1) * 2 - 1}
            </Box>
          ) : (
            <Box className={classes.blackNumBox}>{(parentIndex + 1) * 2}</Box>
          )}
        </>
      )}
    </>
  );
};

export default BoxNumber;
